<template>
  <body class="careers-content-body">
    <BeAPartbanner class="banner" :showLabel="true" :showButton="false" />
    <OpenPositions />
    <!-- <JobAdsSection /> -->
    <JoinOurMission />
    <!-- <WecobiCareers /> -->
  </body>
</template>

<script>
import BeAPartbanner from "../Company/CompanyContent/BeAPartbanner.vue";
import OpenPositions from "./CareersContent/OpenPositions.vue";
// import JobAdsSection from "./CareersContent/JobAdsSection.vue";
import JoinOurMission from "./CareersContent/JoinOurMission.vue";
// import WecobiCareers from "./CareersContent/WecobiCareers.vue";

export default {
  name: "CareersContent",
  components: {
    BeAPartbanner,
    OpenPositions,
    // JobAdsSection,
    JoinOurMission,
    // WecobiCareers,
  },
};
</script>
<style scoped>
.careers-content-body {
  padding: 29px 34px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-sizing: border-box;
}
.banner {
  height: 612px;
}
@media (max-width: 744px) {
  .content-body {
    padding: 21px 17px;
    gap: 16px;
  }
}
@media (max-width: 588px) {
  .banner {
    height: 482px;
  }
}
@media (max-width: 431px) {
  .banner {
    height: 620px;
  }
}
</style>
